<template>
    <span>{{ address }}</span>
</template>

<script>
import Member from '../../js/dto/Member';
import MemberShortProfile from '../../js/dto/MemberShortProfile';

export default {
    props: {
        member: {
            type: [Member, MemberShortProfile],
            required: true,
        },
    },
    computed: {
        address() {
            const addressParts = [];

            if (this.member.careOf) {
                addressParts.push(`c/o ${this.member.careOf}`);
            }
            if (this.member.street) {
                addressParts.push(this.member.street);
            }
            if (this.member.zip || this.member.city) {
                const city = [];
                if (this.member.zip) {
                    city.push(this.member.zip);
                }
                if (this.member.city) {
                    city.push(this.member.city);
                }

                addressParts.push(city.join(' '));
            }

            return addressParts.length === 0 ? '-' : addressParts.join(', ');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
